import styled from 'styled-components';

export const StyledRadioGroup = styled.div<{
  $isInline: boolean;
}>(({
  $isInline,

  theme: {
    indents,
  },
}) => ({
  marginRight: $isInline ? -indents.INDENT_2 : 0,
}));

export const StyledItemWrapper = styled.div<{
  $isInline: boolean;
}>(({
  $isInline,

  theme: {
    indents,
  },
}) => {
  if ($isInline) {
    return {
      display: 'inline-block',
      marginRight: indents.INDENT_2,
    };
  }

  return {
    '& + &': {
      marginTop: indents.INDENT_1,
    },
  };
});
